import React from 'react';

import { Field, reduxForm } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import FlatButton from 'material-ui/FlatButton';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

let reportLatePaymentForm = props => {
  const { handleSubmit } = props;

  return (
    <div>
      <form onSubmit={handleSubmit.bind(this)} id="form_field">
        <div className="row">
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
            <Field
              name="late_fee_amount"
              component={TextField}
              floatingLabelText="Late Fee Amount"
              multiLine={false}
              fullWidth
              validate={[validator.required]}
              style={{ margin: 'auto', marginTop: '-15px', fontSize: '15px', width: '200px' }}
              {...formatter.currencyMask}
            />
          </div>
        </div>
        <div
          className="row"
          style={{
            textAlign: 'center',
            margin: 'auto',
            marginTop: '10px',
            marginBottom: '10px',
          }}
        >
          <FlatButton
            label="Report As Late"
            type="submit"
            className="Delay Payment"
            primary={true}
            disabled={props.isSubmitting}
            backgroundColor={props.isSubmitting ? colors.GRAY : AccentColor()}
            hoverColor="grey"
            style={{ color: 'white', height: '40px' }}
          />
        </div>
      </form>
    </div>
  );
};

reportLatePaymentForm = reduxForm({
  form: 'report_late_payment_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(reportLatePaymentForm);

export default reportLatePaymentForm;
